// https://reactjs.org/tutorial/tutorial.html#setup-option-2-local-development-environment
// to start on port 3000, type npm start
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
      <App />
);

/*
Version    Date        Developer      Comments
1.0.0      01-15-2023  Phil P         Initial release with random computer moves
1.1.0      02-18-2023  Phil P         Split game into several files, pass onePlayerGame & expertMode props
1.2.0      03-04-2023  Phil P         Intro screen updated with number of players and skill level dropdowns and game start button
2.2.0      04-08-2023  Phil P         Created state in the App component and passed setters to children
3.2.0      04-15-2023  Phil P         Added expert skill level
4.2.0      04-22-2023  Phil P         Added intermediate skill level
4.3.0      04-29-2023  Phil P         Added styling for the intro page
4.4.0      05-07-2023  Phil P         Fix issues with intermediate mode logic
4.4.0      05-07-2023  Phil P         Improved intermediate mode logic



*/

/*
Future Plans:
1. On the intro page allow them to pick number of player - if they choose 1, allow novice or expert mode
2. If they choose novice mode, include a button to show a hint on how to win in novice mode?
3. Optional - Depending on time of year, have greeting with graphic for Happy Thanksgiving, Christmas, Easter, 1st day of spring, etc.
4. Fix the ending so it says "you have lost" or "you have won" - might need to add this to the state?
5. Computer won message displays in two player game
6. When resetting to game start it takes two clicks to register first move - first click clears history

Error when playing against computer, what is this? Does not happen in two-player game
Uncaught Error: Too many re-renders. React limits the number of renders to prevent an infinite loop.
I was trying to win and it went into a loop, kept executing this:  
   In game module, going to determine move for this step: 7
   I think the problem is on line 37 in the new game module
   It is not calling handleclick with the computer move on step 7 for some odd reason 
      It re-renders, starts over, and always believes it is the computer's turn again

//NOTES:
//Ready to play needs to be true for game board to be displayed
//putting current time into reRenderGame will force game board to re-render

// Where I left off on 2/25/2023 - drop downs are working and sending data to game
// Still need to hide game until new button "play game" is clicked - then hide dropdowns

// TODO if the user starts a new game, can we clear out the move history? Would that make sense?
  

02/25/2023 Details
State objects
   Number of players - default 0
   Computer skillLevel - default ""
Boolean Object 
   readyToPlay = Number of players = 2 or number of players = 1 & expert mode not null
Start with drop-down for number of players
   if two player, readyToPlay
   if one player and skillLevel not null, readyToPlay

If go back to two player, erase skillLevel dropdown

Notes 0n 3/12/2023:
   slice with reducers and store created
   extra initialization created in App, that is probably not needed
   I think the useSelector at the top of Game will get the current value of every variable whenever it is referenced
   Right now in game we can read the step number
   There might be a problem with setting the history, maybe remove the initialization from App and see if that can be read
   Remember that history is an Array - maybe change history initialization to 9 spaces, then can do history[0].squares.toString()
      Just a thought
   It still might be correct to use useEffect to execute render but not sure if that runs before first render or after 

   New Notes - have the main function at the top of the page, include the return at the bottom of that function
      The main function can call all other functions
      Global variables should be above the main function
      We do not need useEffect unless we want to force a re-render when some variable changes, that would not be called before first render

Notes on 03/26/2023:
   For some reason cannot use dispatch with an array (squares)
      Uncaught Error: Actions must be plain objects. Instead, the actual type was: 'array'. You may need to add middleware to your store 
      setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. 

      Used an array to string conversion to send strings to the store, this is what it says now:

      Uncaught Error: Actions must be plain objects. Instead, the actual type was: 'string'. You may need to add middleware to your store 
      setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions.

Ending notes on 03/26/2023:
   MOved the history state to useState in the Game component
   When processMove changes the history it needs to send a new copy to the Game component, it will control history
   Two player game is working now
   Now there is a problem in App, cannot get the skill dropdown when setting onePLayerGame = true
   Perhaps move the re-render key to the root div - no, that did not help

Notes on 04/01/2023:
   Adding "onePlayerGame" to useState in the app component - it will also be in global state
   Global state does not work - the slice is not receive the dispatch call and receiving a stupid error, removing from global state - will pass to Game as prop
      Actions must be plain objects. Instead, the actual type was: 'undefined'. You may need to add middleware to your store setup to handle dispatching 
      other values, such as 'redux-thunk' to handle dispatching functions.
   ProcessMove creates a new history array which is correctly sent back to Game but Game cannot employ useState to update history with new array
      I moved the history definition to the parent component App and sent a callback function down to Game so Game will re-render and see new state
   Now the JumpToStep function is receiving an error
      react-dom.development.js:16227 Uncaught Error: Invalid hook call. Hooks can only be called inside of the body of a function component. 
      This could happen for one of the following reasons:
         1. You might have mismatching versions of React and the renderer (such as React DOM)
         2. You might be breaking the Rules of Hooks
         3. You might have more than one copy of React in the same app
      You cannot call a hook within a function but you can call a custom hook to accomplish this, see: https://hy.reactjs.org/docs/hooks-rules.html

Notes on 04/08/2023:
   I created a custom hook called useJumpToStep and how this is what it is saying for the Game.js file:
        Line 94:32:  React Hook "useJumpToStep" cannot be called inside a callback. React Hooks must be called in a React function component or a custom React Hook function
        Look at this: https://stackoverflow.com/questions/58821668/react-custom-hooks-in-callback
        This might be better: https://react.dev/warnings/invalid-hook-call-warning
   Okay, I am giving up on hooks, slices, and redux. It is just too complicated and the documentation makes no sense. Whatever I try it says I am breaking the rules!
   Now seeing this Warning: Cannot update a component ('App') while rendering a different component ('Game)
      Looking at the stack trace we are going from
         processMove line 36 (setting the step number at the end of the function)
         Game 83  handleComputerMove which called processMove
         Game 167 where we called handleComputerMove
      https://stackoverflow.com/questions/62336340/cannot-update-a-component-while-rendering-a-different-component-warning
   Where I stopped today (still intermittently seeing that stupid error about a component being updated)
   DetermineComputerMove has a switch statement based on skill level
   All roads lead to ComputerMoveNovice today
   I threw a bunch of code into ComputerMoveMedium - I do not know if we want to go beyond the first move, Novice is already difficult enough

Notes on 4/15/2023
   I have imported the AI engine into the expert mode module
   It works fine in codepen and I can add console.log entries to look at all variables
   In my version it just loops and runs out of memory
   I have added code to convert our game board to their format
   There is now a return statement at the very top of the function but it still loops through the minmax function recursively until it runs out of memory
   In the main loop it seems to be processing position 0 endlessly without moving to a new position
   The expert mode is working now!!

   Notes on 04/22/2023: Intermediate mode is working now

   Notes on 04/28/2023:
      Need to fix styling on intro page - dropdown should look like sample from class
      Need to fix the ending messages of the game - might need to add a state item


*/




